import IApiClient from "./ApiClient";
import {Company, CompanyResponse, ResponseStatus, ActiveProductsResponse, CompanyOrgResponse, UpdateCompanyResponse} from "models/Company"

export interface ICompanyService {
    getCompany(id: string): Promise<CompanyResponse | undefined>;
  }

export default class CompanyService implements ICompanyService{
    apiBase: string;
    apiClient: IApiClient;
  
    constructor(apiClient: IApiClient) {
      this.apiBase = '/api/company';
      this.apiClient = apiClient;
    }
  
    async addUserConcent(organizationnumber:string,id: string): Promise<ResponseStatus|undefined> {
      try {
        const response = await this.apiClient.post<null,ResponseStatus>(`${this.apiBase}/addconsent/${organizationnumber}/${id}`,null);
        return response ? response : undefined;
      } catch (exception) {
        console.error(exception);
      }
    }

    async getCompany(id: string): Promise<CompanyResponse|undefined> {
      try {
        const response = await this.apiClient.get<CompanyResponse>(
          `${this.apiBase}/get/${id}`
        );
        return response ? response : undefined;
      } catch (exception) {
        console.error(exception);
      }
    }

    async getCompanyProducts(id: string): Promise<ActiveProductsResponse|undefined> {
      try {
        const response = await this.apiClient.get<ActiveProductsResponse>(
          `${this.apiBase}/getproducts/${id}`
        );
        return response ? response : undefined;
      } catch (exception) {
        console.error(exception);
      }
    }

    async getCompanyByOrgNumber(orgnumber: string): Promise<CompanyOrgResponse|undefined> {
      try {
        const response = await this.apiClient.get<CompanyOrgResponse>(
          `${this.apiBase}/get/organizationnumber/${orgnumber}`
        );
        return response ? response : undefined;
      } catch (exception) {
        console.error(exception);
      }
    }

    async updateCompany(company: Company): Promise<UpdateCompanyResponse|undefined> {
      try {
        const response = await this.apiClient.post<Company,UpdateCompanyResponse>(`${this.apiBase}/update`, company);
        return response ? response : undefined;
      } catch (exception) {
        console.error(exception);
      }
    }
  
    // async updateStatus(
    //   profileId: number,
    //   newStatus: ProfileStatus
    // ): Promise<boolean> {
    //   try {
    //     await this.profileApiClient.put(
    //       `${this.apiBase}/waitlisters/${profileId}`,
    //       { tester: { status: newStatus } }
    //     );
    //     return true;
    //   } catch (exception) {
    //     console.error(exception);
    //     return false;
    //   }
    // }
  }